import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '../../lib/components/Button';
import Typography from '../../lib/components/Typography';
import findhouseImage from '../../assets/findhouse.png';
import personaliseAnalysisImage from '../../assets/personalise-analysis.png';
import selectInstallationImage from '../../assets/select-installation.png';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.light,
    overflow: 'hidden',
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(15),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  action: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  title: {
    marginBottom: theme.spacing(14),
  },
  number: {
    fontSize: 48,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  image: {
    height: 150,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
    opacity: 0.7,
  },
  button: {
    marginTop: theme.spacing(8),
  },
});

function ProductHowItWorks(props) {
  const { classes } = props;

  return (
    <section className={classes.root} id="howitworks">
      <Container className={classes.container}>
        <img
          src="/static/themes/onepirate/productCurvyLines.png"
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Typography variant="h4" marked="center" className={classes.title} component="h2">
          How it works
        </Typography>

        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img
                  src={findhouseImage}
                  alt="find house"
                  className={classes.image}
                />
                <div className={classes.number}>1<br /><br /></div>
                <div className={classes.action}>Search your home<br /><br /></div>
                <Typography variant="h5" align="center">
                  We use Google Earth imagery to analyze your roof shape and local weather patterns to create a personalized solar plan.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img
                  src={personaliseAnalysisImage}
                  alt="personalise analysis"
                  className={classes.image}
                />
                <div className={classes.number}>2<br /><br /></div>
                <div className={classes.action}>Personalize your analysis<br /><br /></div>
                <Typography variant="h5" align="center">
                  Adjust your electric bill to fine-tune your savings estimate and the recommended number of solar panels for your home..
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img
                  src={selectInstallationImage}
                  alt="select installation"
                  className={classes.image}
                />
                <div className={classes.number}>3<br /><br /></div>
                <div className={classes.action}>Select installation options<br /><br /></div>
                <Typography variant="h5" align="center">
                  We use Google Earth imagery to analyze your roof shape and local weather patterns to create a personalized solar plan.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        {/* <Button
          color="secondary"
          size="large"
          variant="contained"
          className={classes.button}
          component="a"
          href="/premium-themes/onepirate/sign-up/"
        >
          Get started
        </Button> */}
      </Container>
    </section>
  );
}

ProductHowItWorks.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHowItWorks);